import { useRouteError } from 'react-router-dom';
import { Box, Typography } from '@mui/material';

export default function Error() {
  const error = useRouteError();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      width="100%"
      height="100vh"
      gap={2}>
      <Typography variant="h3">Oops!</Typography>
      <Typography variant="body1">Sorry, an unexpected error has occurred.</Typography>
      <Typography variant="body1">
        <i>{error.statusText || error.message}</i>
      </Typography>
    </Box>
  );
}
